import React from 'react'

const styles = {width: '99vw', height: '88vh'};

function Ventas() {
    return (
        <iframe
        title='Ventas'
        src="https://geologiaconce.maps.arcgis.com/apps/dashboards/8e34d5823f164258be0acc618bcec81a" 
        style={styles}>
        </iframe>
    )
}

export default Ventas
